export type SupplyDataset = 'requests' | 'orders' | 'receipts'

export type SupplyRow = Record<string, string | number | boolean | null>

export interface SupplyDocument {
  headers: SupplyRow[]
  items: SupplyRow[]
  related: SupplyRow[]
  origins: SupplyRow[]
  form: Array<{
    group_name: string
    group_id: number
    sort_order: number
    fields: Array<{
      name: string
      value: string
      title: string
      input: { type: string }
      options: { disabled: boolean }
    }>
  }>
}

export const supplySections: Record<
  SupplyDataset,
  { path: string; title: string; cardTitle: string; searchPlaceholder: string }
> = {
  requests: {
    path: '/procurement/requests',
    title: 'Заявки на снабжение',
    cardTitle: 'Заявка на снабжение',
    searchPlaceholder: 'Номер заявки 1С или WD',
  },
  orders: {
    path: '/procurement',
    title: 'Закупки',
    cardTitle: 'Заказ поставщику',
    searchPlaceholder: 'Номер заказа 1С',
  },
  receipts: {
    path: '/warehouse',
    title: 'Склад · поступления',
    cardTitle: 'Приходная накладная',
    searchPlaceholder: 'Номер приходной накладной',
  },
}

export const supplyCardPath = (dataset: SupplyDataset, number: string) =>
  `${supplySections[dataset].path}/${encodeURIComponent(number)}`

export const supplyText = (value: SupplyRow[string] | undefined) =>
  value == null || value === '' ? '—' : String(value)

export const supplyMoney = (value: SupplyRow[string] | undefined) =>
  typeof value === 'number'
    ? new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value)
    : '—'

export const supplyDate = (value: SupplyRow[string] | undefined) => {
  if (typeof value !== 'string' || value.length < 10) return '—'
  const [year, month, day] = value.slice(0, 10).split('-')
  const time = value.length >= 16 ? value.slice(11, 16) : ''
  return `${day}.${month}.${year}${time && time !== '00:00' ? ` ${time}` : ''}`
}

export const supplyDeliveryDate = (value: SupplyRow[string] | undefined) =>
  typeof value === 'string' && !value.startsWith('0001-') ? supplyDate(value) : '—'

export const supplyDeliveryPeriod = (value: string) => {
  const match = /^(\d{4})\.(\d{2})\.(\d{2})-(\d{4})\.(\d{2})\.(\d{2})$/.exec(value)
  if (!match) return undefined
  const from = `${match[1]}-${match[2]}-${match[3]}`
  const through = `${match[4]}-${match[5]}-${match[6]}`
  const dates = [from, through].map(date => new Date(`${date}T00:00:00Z`))
  if (dates.some((date, index) => !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== [from, through][index]) || from > through) return undefined
  dates[1].setUTCDate(dates[1].getUTCDate() + 1)
  return { from, to: dates[1].toISOString().slice(0, 10) }
}
